import React, { useState, useEffect, useCallback } from 'react';
import './df-form-comments.scss';

interface DfFormCommentsProps {
  comment?: string;
  onSave?: (comment: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export const DfFormComments: React.FC<DfFormCommentsProps> = ({
  comment = '',
  onSave,
  placeholder = 'Enter your reason...',
  className = '',
  disabled = false
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(true);
  const [currentComment, setCurrentComment] = useState<string>(comment);
  const [hasChanges, setHasChanges] = useState<boolean>(false);

  // Update local state when comment prop changes
  useEffect(() => {
    setCurrentComment(comment);
    setHasChanges(false);
  }, [comment]);

  // Handle input changes
  const handleInputChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setCurrentComment(newValue);
    setHasChanges(newValue !== comment);
  }, [comment]);

  // Handle input blur with auto-save
  const handleInputBlur = useCallback(() => {
    if (hasChanges && onSave && !disabled) {
      onSave(currentComment);
      setHasChanges(false);
    }
  }, [hasChanges, onSave, currentComment, disabled]);

  // Handle input focus
  const handleInputFocus = useCallback(() => {
    // Focus handler if needed
  }, []);

  // Toggle comments section
  const toggleComments = useCallback(() => {
    if (!disabled) {
      setIsExpanded(!isExpanded);
    }
  }, [isExpanded, disabled]);


  return (
    <div className={`df-form-comments ${className}`}>
      <div className="df-form-comments__header">
        <h3 className="df-form-comments__title">Comments</h3>
        <button
          className="df-form-comments__toggle"
          type="button"
          onClick={toggleComments}
          aria-expanded={isExpanded}
          aria-label="Toggle comments section"
          disabled={disabled}
        >
          {isExpanded ? (
            <span className="df-form-comments__toggle-icon">▼</span>
          ) : (
            <span className="df-form-comments__toggle-icon">▶</span>
          )}
        </button>
      </div>

      <div className={`df-form-comments__content ${isExpanded ? 'df-form-comments__content--expanded' : ''}`}>
        <div className="df-form-comments__input-container">
          <div className="df-form-comments__input-line">
            <input
              type="text"
              id="comment-input"
              className="df-form-comments__input"
              value={currentComment}
              onChange={handleInputChange}
              onBlur={handleInputBlur}
              onFocus={handleInputFocus}
              placeholder={placeholder}
              disabled={disabled}
            />
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default DfFormComments;
